import {proxy} from 'valtio';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import {UI_CONSTANTS} from '@/constants/messages';

export const visitor = proxy({
    count: UI_CONSTANTS.GUEST_INITIAL_COUNT,
    visitorId: '',

    async getFingerprint() {
      if (this.visitorId) return this.visitorId; // 内存缓存

      const fp = await FingerprintJS.load();
      const { visitorId } = await fp.get();
      this.visitorId = visitorId;

      // 初始化次数
      const saved = localStorage.getItem(visitorId);
      this.count = saved ? parseInt(saved) : UI_CONSTANTS.GUEST_INITIAL_COUNT;

      return visitorId;
    },

    getFingerprintAlterInit() {
        return this.visitorId;
    },

    async useFeature() {
      await this.getFingerprint(); // 确保已初始化
      if (this.count <= 0) return false;

      this.count--;
      localStorage.setItem(this.visitorId, this.count.toString());
      return true;
    }
  });